import { isDedicatedDeskRoom } from '@wework/floormap-utils'
import changeCase from 'change-case'

export const isSpaceInteractable = (space, floorMap) => {
  if (space.reservable) {
    return true
  }

  if (space.subType === 'DESK' || space.subType === 'TABLE') {
    return false
  }

  if (space.subType === 'CHAIR' || space.subType === 'SEAT') {
    if (!space.spaceUUID) {
      return false
    }

    const parentRoom = floorMap?.getSpaceById(space?.spaceUUID)
    if (!parentRoom) {
      return false
    }
    if (!isDedicatedDeskRoom(parentRoom.subType, parentRoom.roomTypeUUID)) {
      return false
    }
  }
  return true
}

export const getUnholdedOnly = spaces => {
  return spaces.filter(
    space => space.reservable && !space.reservable?.officeHold
  )
}

export const getType = (space: any): string => {
  const subType = space.subType?.toUpperCase()
  const programType = space.programType?.toUpperCase()
  let type = ''
  if (subType === 'PRIVATE OFFICE') {
    type = 'Office'
  } else if (programType === 'MEET') {
    type = 'Meeting Room'
  } else {
    type = changeCase.title(subType)
  }
  return type
}

export const getProductType = (space: any): string => {
  let productType: string
  let type: string
  type = getType(space)
  if (space?.inventoryData && space.inventoryData?.relationships?.length > 0) {
    productType = space.inventoryData?.relationships[0]?.product_type
    type = changeCase.title(productType.replace('_', ' '))
  }
  return type
}

export const getProductName = (space: any): string => {
  let name: string
  name = space.reservable?.officeNumber
  if (space?.inventoryData && space.inventoryData?.relationships?.length > 0) {
    name = space.inventoryData?.relationships[0]?.name
  }
  return name
}
